import { Injectable } from '@angular/core';

interface Scripts {
  name: string;
  src: string;
}

// export const ScriptStore: Scripts[] = [
//   {
//     name: 'chartjs',
//     src: 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.7.2/Chart.bundle.min.js'
//   }
// ];

declare var document: any;

@Injectable()
export class DynamicScriptLoaderService {
  private scripts: any = {};
  // private dataFromBottomSheet = new BehaviorSubject({});
  // currentData = this.dataFromBottomSheet.asObservable();

  constructor() {
    // ScriptStore.forEach((script: any) => {
    //   this.scripts[script.name] = {
    //     loaded: false,
    //     src: script.src
    //   };
    // });
  }

  // getScripts(data: any) {
  //   this.dataFromBottomSheet.next(data);
  // }

  load(...scripts: string[]) {
    // console.log('load ...');
    const promises: any[] = [];
    scripts.forEach(script => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      if (!this.scripts[name].loaded || this.scripts[name].src == name) {
        // load script
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        if (script.readyState) {
          // IE
          script.onreadystatechange = () => {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
              script.onreadystatechange = null;
              this.scripts[name].loaded = true;
              resolve({ script: name, loaded: true, status: 'Loaded' });
            }
          };
        } else {
          // Others
          script.onload = () => {
            this.scripts[name].loaded = true;
            resolve({ script: name, loaded: true, status: 'Loaded' });
          };
        }
        script.onerror = () => resolve({ script: name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      }
    });
  }

  addScript(src: string) {
    this.scripts[src] = {
      loaded: false,
      src: src
    };
  }
}
